// For further reference: https://ably.com/docs/getting-started/react#prerequisites-ably-pubsub

import { useAbly, useConnectionStateListener } from "ably/react";
import { useState } from "react";

export function ConnectionState() {
  const ably = useAbly();
  const [connectionState, setConnectionState] = useState(ably.connection.state);

  useConnectionStateListener((stateChange) => {
    setConnectionState(stateChange.current);
  });

  return (
    <div className="h-full mt-4 text-center">
      {/* <p>Connection: {connectionState}!</p> */}
    </div>
  );
}
